import React from 'react';
import { Link } from 'react-router-dom';

import './Header.scss';

import btnBack from '../img/btn-back.png';
import btnHamburger from '../img/btn-hamburger.png';
import Sidebar from './Sidebar';
import { LocaleContext } from '../lib/Locale';
import UserRoleProtected from './UserRoleProtected';
import { EditingContext } from '../lib/Editable';
import { Clearance } from '../data/sessionSlice';
import { Location } from '../pages/Location';

type HeaderProps = {
  page: Location;
  backLink: string;
  addedToCart?: number;
};

export class Header extends React.Component<HeaderProps> {
  state = {
    navOpen: false,
  };

  render() {
    return (
      <header className="header">
        <Link to={this.props.backLink} className="btn-back">
          <img src={btnBack} alt="Home" />
        </Link>
        {this.renderTitle(this.props.page)}
        <div>
          {this.maybeRenderEditButton()}
          {this.maybeRenderLocalePicker()}
          {this.maybeRenderCartButton()}
          {this.renderHamburgerMenu()}
        </div>
        <Sidebar open={this.state.navOpen} onClose={() => this.setState({ navOpen: false })} />
      </header>
    );
  }

  renderTitle(page: Location) {
    switch (page) {
      case 'walls':
        return <h2>-Walls-</h2>;
      case 'drawings':
        return <h2>-Drawings-</h2>;
      case 'sketches':
        return <h2>-Sketches-</h2>;
      case 'tattoos':
        return <h2>-Tattoos-</h2>;
      case 'projects':
        return <h2>-Projects-</h2>;
      case 'others':
        return <h2>-Others-</h2>;
      case 'shop':
        return <h2>-Shop-</h2>;
      case 'press':
        return <h2>-Press-</h2>;
      default:
        throw new Error(`Unknown page: ${page}`);
    }
  }

  maybeRenderEditButton() {
    return (
      <EditingContext.Consumer>
        {(editing) => {
          if (!editing.editable) {
            return '';
          }
          if (editing.editing) {
            return (
              <UserRoleProtected clearance={Clearance.InDevelopment} protectedStyle="unlaunched">
                <button className="btn-edit" onClick={() => editing.save()}>
                  Save
                </button>
              </UserRoleProtected>
            );
          }
          return (
            <UserRoleProtected clearance={Clearance.InDevelopment} protectedStyle="unlaunched">
              <button className="btn-edit" onClick={() => editing.setEditing()}>
                Edit
              </button>
            </UserRoleProtected>
          );
        }}
      </EditingContext.Consumer>
    );
  }

  maybeRenderLocalePicker() {
    return (
      <LocaleContext.Consumer>
        {(locale) => {
          const currentLanguage = locale.language;
          const otherLanguage = currentLanguage === 'en' ? 'it' : 'en';
          return locale.showingMultiLocaleContent ? (
            <button className="btn-locale" onClick={() => locale.setLanguage(otherLanguage)}>
              {currentLanguage}
            </button>
          ) : (
            ''
          );
        }}
      </LocaleContext.Consumer>
    );
  }

  maybeRenderCartButton() {
    return (
      <UserRoleProtected protectedStyle="unlaunched" clearance={Clearance.ComingSoon}>
        {this.props.addedToCart ? (
          <Link to="/shop/cart" className="cartIcon">
            {this.props.addedToCart}
          </Link>
        ) : (
          ''
        )}
      </UserRoleProtected>
    );
  }

  renderHamburgerMenu() {
    return (
      <button className="btn-menu" onClick={() => this.setState({ navOpen: true })}>
        <img src={btnHamburger} alt="Menu" />
      </button>
    );
  }
}
